<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 협의체 구성</h5>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col class="w-6/12">
        <table-custom
          :controls="true"
          :multiple="true"
          :board="board"
          :is-print="isPrint"
          title="- 도급자"
          title-type="small"
          :tableData="[
            { id: 'name', title: '이름', type: 'text', placeholder: '' },
            {
              id: 'position',
              title: '직책',
              type: 'select',
              selectData: ['구청장', '부서장', '팀장', '담당', '주무관(기타)',],
              placeholder: '선택',
            },
          ]"
          v-model="form.tableList_1"
          class="mr-4"
        />
      </vs-col>
      <vs-col class="w-6/12">
        <table-custom
          :controls="true"
          :multiple="true"
          :board="board"
          :is-print="isPrint"
          title="- 수급자"
          title-type="small"
          :tableData="[
            { id: 'name', title: '이름', type: 'text', placeholder: '' },
            {
              id: 'position',
              title: '직책',
              type: 'text',
              placeholder: '선택',
            },
          ]"
          v-model="form.tableList_2"
          class="ml-4"
        />
      </vs-col>
    </vs-row>

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint"
                        :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import DateSelector from '@/components/selector/DateSelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    FieldSelectModule,
    FileUploader,
    DateSelector,
    FileUploadModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },

  data () {
    return {
      form: {
        stdInfo:{},
        fileList: [],
        tableList_1: [],
        tableList_2: [],
        tableCount: 0,
      },
    }
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(this.form);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.tableList_1': {
      immediate: true,
      deep: true,
      handler() {
        this.updateTableCount();
      },
    },
    'form.tableList_2': {
      immediate: true,
      deep: true,
      handler() {
        this.updateTableCount();
      },
    },
  },
  methods: {
    updateTableCount() {
      this.form.tableCount = this.form.tableList_1.length + this.form.tableList_2.length;
    },
  },
}
</script>

<style scoped>

</style>
